export default __webpack_public_path__ + "assets/upload_logo_market.a7325b.png";